$(function() {
  let headerHeight = $('#MainHeader').outerHeight();

  $('.announcement-close').click(function() {
    $('.announcement-bar').hide();

    if ($('.pdp-tabs').length > 0) {
      headerHeight = $('#MainHeader').outerHeight();
      $('.pdp-tabs').css('top', headerHeight);
      $('.dropdown-close').css('top', headerHeight);
    }
  });

  if ($(window).width() >= 769) {
    $('.featured-collections-custom .grid').flickity({
      cellAlign: 'left',
      pageDots: false,
      groupCells: true
    });

    $('.MediaReviews').flickity({
      cellAlign: 'left',
      groupCells: false,
      pageDots: false
    });

  } else {
    $('.featured-collections-custom .grid').flickity({
      cellAlign: 'left',
      prevNextButtons: false,
      freeScroll: true
    });

    $('.MediaReviews').flickity({
      prevNextButtons: false
    });

    $('.BlogArticles').flickity({
      pageDots: false
    });
  }

  var backToTopBtn = $('#back-to-top-btn');

   $(window).scroll(function() {
     if ($(window).scrollTop() > 300) {
       backToTopBtn.addClass('show');
     } else {
       backToTopBtn.removeClass('show');
     }
   });

   backToTopBtn.on('click', function(e) {
     e.preventDefault();
     $('html, body').animate({scrollTop:0}, '300');
   });

   $('.header-custom .collapsible-trigger').click(function() {
     $('#NavDrawer').addClass('submenu-open');
   });

   $('.submenu-back-button').click(function() {
     $(this).parents('li.mobile-nav__item').find('.mobile-nav__has-sublist button.collapsible-trigger').trigger('click');
     $('#NavDrawer').removeClass('submenu-open');
   });

   $('.site-nav--has-dropdown').click(function(e) {
     if ($(e.target).hasClass('site-nav__link--has-dropdown')) {
       e.preventDefault();
       $currentLink = $(this);

       if ($currentLink.hasClass('dropdown-active')) {
         closeDropdownEffects();
       } else {
         $('.site-nav--has-dropdown').removeClass('dropdown-active');
         $currentLink.addClass('dropdown-active');
         $('.main-content').addClass('dropdown-is-open');
       }
     }
   });

   $('.dropdown-close').click(function() {
     closeDropdownEffects();
   });


   $('.dropdown-close').css('top', headerHeight);

   function closeDropdownEffects() {
     $('.site-nav--has-dropdown').removeClass('dropdown-active');
     $('.main-content').removeClass('dropdown-is-open');
     $('.main-content').addClass('dropdown-closing');
     setTimeout(function() {
       $('.main-content').removeClass('dropdown-closing').removeClass('dropdown-is-open');
     }, 350);
   }
});
